import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from '../../../atoms/Button/Button';
import Card from '../../../atoms/Card/Card';
import Menu from '../../../atoms/Menu/Menu';
import RadioButton from '../../../atoms/RadioButton/RadioButton';
import { getFromLocalStorage, saveToLocalStorage } from '../../../Functions/LocalStorageUtils';
import { setAIAssistant } from '../../../redux/reducers/settingsReducer';
import { useAppDispatch, useAppSelector } from '../../../redux/store';

import styles from './ExperimentalSetting.module.scss';

const ExperimentalSetting: React.FC = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        const stored = {
            use_ai_assistant: getFromLocalStorage('use_ai_assistant') === 'true'
        }
        dispatch(setAIAssistant(stored.use_ai_assistant));
    }, [dispatch]);

    const settings: {setting: string, label: string, active: boolean}[] = [
        {
            setting: 'use_ai_assistant',
            label: t('settings.experimental_settings.use_ai_assistant'),
            active: useAppSelector((state) => state.settings.use_ai_assistant)
        }
    ];

    const handleSettingChange = (s: {setting: string, label: string, active: boolean}) => {
        saveToLocalStorage(s.setting, (!s.active).toString());
        dispatch(setAIAssistant(!s.active));
    }

    return (
        <div className={styles.Container}>
            <div>
                <h2 className={styles.Heading}>{t('settings.experimental_settings.heading')}</h2>
            </div>
            <Card width="36rem" padding="1.5rem">
                <Menu orientation="vertical">
                    {settings.map((s) => (
                        <Menu.Item
                            key={s.setting}
                            variant="primary"
                            isactive={s.active}
                            onClick={() => handleSettingChange(s)}
                        >
                            <Menu.ItemLeft>{s.label}</Menu.ItemLeft>
                            <Menu.ItemRight>
                                <RadioButton group="settings_experimental" checked={s.active} />
                            </Menu.ItemRight>
                        </Menu.Item>
                    ))}
                </Menu>
                <Button variant="fill" margin="1.5rem 0 0 0" padding=".5rem 1rem" 
                    onClick={() => navigate('../../')} >
                        {t('save')}
                    </Button>
            </Card>
        </div>
    );
}

export default ExperimentalSetting;